﻿<template>
    <header class="header mb-app-header">
        <header_menu></header_menu>
    </header>

    <main class="mb-shell">
        <div class="mb-page">
            <nav class="mb-breadcrumb" aria-label="Breadcrumb">
                <a @click="Go_Home()">
                    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M341.8 72.6C329.5 61.2 310.5 61.2 298.3 72.6L74.3 280.6C64.7 289.6 61.5 303.5 66.3 315.7C71.1 327.9 82.8 336 96 336L112 336L112 512C112 547.3 140.7 576 176 576L464 576C499.3 576 528 547.3 528 512L528 336L544 336C557.2 336 569 327.9 573.8 315.7C578.6 303.5 575.4 289.5 565.8 280.6L341.8 72.6zM304 384L336 384C362.5 384 384 405.5 384 432L384 528L256 528L256 432C256 405.5 277.5 384 304 384z"/></svg>
                    Home
                </a>
                <span class="mb-sep">/</span>
                <span class="mb-current">My Profile</span>
            </nav>

            <div class="mb-page-header">
                <div>
                    <h1>My Profile</h1>
                    <p class="mb-subtitle" v-if="Get_Agency_Name()">
                        Account <strong>{{ Get_Agency_Name() }}</strong>
                    </p>
                </div>
                <div class="pf-chip" v-if="Get_Contact()">
                    <span class="bd-avatar" aria-hidden="true">{{ Get_Initials() }}</span>
                    <span class="min-w-0">
                        <span class="pf-chip-name">{{ Get_Contact_Name() || 'Consultant' }}</span>
                        <span class="pf-chip-email">{{ Get_Contact()?.email }}</span>
                    </span>
                </div>
            </div>

            <div class="pf-grid">
                <div class="pf-col">
                    <consultant_information v-if="Get_Contact()" :selected_contact="Get_Contact()"></consultant_information>
                    <account_information></account_information>
                </div>
                <div class="pf-col">
                    <change_account_password></change_account_password>
                </div>
            </div>
        </div>
    </main>

</template>

<script lang="ts" src="./my_profile.ts"></script>